var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35793 7.47504C8.11385 7.23096 7.71813 7.23096 7.47405 7.47504C7.22997 7.71912 7.22997 8.11484 7.47405 8.35892L9.11545 10.0003L7.47407 11.6417C7.22999 11.8858 7.22999 12.2815 7.47407 12.5256C7.71814 12.7697 8.11387 12.7697 8.35795 12.5256L9.99933 10.8842L11.6407 12.5256C11.8848 12.7696 12.2805 12.7696 12.5246 12.5256C12.7687 12.2815 12.7687 11.8858 12.5246 11.6417L10.8832 10.0003L12.5246 8.35894C12.7687 8.11486 12.7687 7.71913 12.5246 7.47506C12.2805 7.23098 11.8848 7.23098 11.6407 7.47506L9.99933 9.11644L8.35793 7.47504Z",
    fill: "#F87171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.04199C5.0518 1.04199 1.04102 5.05277 1.04102 10.0003C1.04102 14.9479 5.0518 18.9587 9.99935 18.9587C14.9469 18.9587 18.9577 14.9479 18.9577 10.0003C18.9577 5.05277 14.9469 1.04199 9.99935 1.04199ZM2.29102 10.0003C2.29102 5.74313 5.74215 2.29199 9.99935 2.29199C14.2565 2.29199 17.7077 5.74313 17.7077 10.0003C17.7077 14.2575 14.2565 17.7087 9.99935 17.7087C5.74215 17.7087 2.29102 14.2575 2.29102 10.0003Z",
    fill: "#F87171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35793 7.47504C8.11385 7.23096 7.71813 7.23096 7.47405 7.47504C7.22997 7.71912 7.22997 8.11484 7.47405 8.35892L9.11545 10.0003L7.47407 11.6417C7.22999 11.8858 7.22999 12.2815 7.47407 12.5256C7.71814 12.7697 8.11387 12.7697 8.35795 12.5256L9.99933 10.8842L11.6407 12.5256C11.8848 12.7696 12.2805 12.7696 12.5246 12.5256C12.7687 12.2815 12.7687 11.8858 12.5246 11.6417L10.8832 10.0003L12.5246 8.35894C12.7687 8.11486 12.7687 7.71913 12.5246 7.47506C12.2805 7.23098 11.8848 7.23098 11.6407 7.47506L9.99933 9.11644L8.35793 7.47504Z",
    stroke: "#F87171",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.04199C5.0518 1.04199 1.04102 5.05277 1.04102 10.0003C1.04102 14.9479 5.0518 18.9587 9.99935 18.9587C14.9469 18.9587 18.9577 14.9479 18.9577 10.0003C18.9577 5.05277 14.9469 1.04199 9.99935 1.04199ZM2.29102 10.0003C2.29102 5.74313 5.74215 2.29199 9.99935 2.29199C14.2565 2.29199 17.7077 5.74313 17.7077 10.0003C17.7077 14.2575 14.2565 17.7087 9.99935 17.7087C5.74215 17.7087 2.29102 14.2575 2.29102 10.0003Z",
    stroke: "#F87171",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.700a0b64174f9b975482eee1b1124438.svg";
export { ForwardRef as ReactComponent };